import axiosInstance from './axiosConfig';

export const getUsersApi = (params) => axiosInstance.get('/users', { params });
export const getUserApi = (id) => axiosInstance.get(`/users/${id}`);
export const createUserApi = (payload) => axiosInstance.post('/users', payload);
export const updateUserApi = (id, payload) => axiosInstance.put(`/users/${id}`, payload);
export const deactivateUserApi = (id) => axiosInstance.delete(`/users/${id}`);